import React from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Input,
  Label,
} from 'reactstrap';
import Pagination from './Pagination';
import CarrierList from './CarrierList';
import details from './models';

class EditSection extends React.PureComponent {
  render() {
    const {
      logosList,
      editMultipleSelections,
      editLogoMode,
      organizationActivePage,
      organizationsList,
      organizationFilter,
      organizationsToEdit,
      dispatch,
    } = this.props;

    const filteredOrgList = organizationsList.filter((org) => (
      organizationFilter
      && (
        !org.organization_name
          .toLowerCase()
          .includes(organizationFilter.toLowerCase())
      )
        ? null : org
    ));

    const filteredAndPagedArray = [];
    for (let i = 0; i < filteredOrgList.length; i += 25) {
      filteredAndPagedArray.push(filteredOrgList.slice(i, i + 25));
    }

    let checkboxStatus = true;
    if (editLogoMode === 'multiple' && filteredAndPagedArray[organizationActivePage - 1]) {
      filteredAndPagedArray[organizationActivePage - 1].forEach((o) => {
        const present = organizationsToEdit.filter((org) => org.id === o.id);
        if (!present.length) {
          checkboxStatus = false;
        }
      });
    } else {
      checkboxStatus = false;
    }

    return (
      <>
        {
          editLogoMode === 'multiple'
            ? (
              <div className="mx-5 mb-4 fade-in">
                <div className="mb-5">
                  <div>1. Select logo or enter a display name...</div>
                  <div className="d-flex my-3">
                    <div className="me-2">
                      <Label className="font-weight-bold">Logo</Label>
                      <Input
                        type="select"
                        name="select"
                        id="select"
                        onChange={(e) => { dispatch({ type: 'SET_EDIT_MULTIPLE_SELECTION', payload: { id: 'logo_id', value: e.target.value } }); }}
                        value={editMultipleSelections.logo_id || ''}
                        disabled={editMultipleSelections.display_name}
                      >
                        <option value={null}>{' '}</option>
                        {
                          logosList.map((logo) => (
                            <option value={logo.id}>{logo.logo_name}</option>
                          ))
                        }
                        <option value="null">Remove Logo</option>
                      </Input>
                    </div>
                    <div>
                      <Label className="font-weight-bold">Display Name</Label>
                      <Input
                        value={editMultipleSelections.display_name || ''}
                        onChange={(e) => { dispatch({ type: 'SET_EDIT_MULTIPLE_SELECTION', payload: { id: 'display_name', value: e.target.value } }); }}
                        disabled={editMultipleSelections.logo_id}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  2. Then check the box next to each carrier to be updated...
                </div>
              </div>
            ) : null
        }
        <Pagination />
        <Table size="sm" className="font-small mb-0 fade-in">
          <thead className="bg-gray">
            <tr>
              <th className="text-center p-0 ps-1" style={{ verticalAlign: 'middle' }}>
                {editLogoMode === 'multiple'
                  ? (
                    <input
                      className="form-control"
                      type="checkbox"
                      id="organizationAllSelect"
                      checked={checkboxStatus}
                      onClick={(e) => {
                        if (e.target.checked) {
                          filteredAndPagedArray[organizationActivePage - 1].forEach((o) => {
                            const present = organizationsToEdit.filter((org) => org.id === o.id);
                            if (!present.length) {
                              dispatch({
                                type: 'HANDLE_ORG_EDIT_CHECKBOX',
                                payload: {
                                  checked: true,
                                  organization: o,
                                },
                              });
                            }
                          });
                        } else {
                          filteredAndPagedArray[organizationActivePage - 1].forEach((o) => {
                            const present = organizationsToEdit.filter((org) => org.id === o.id);
                            if (present.length) {
                              dispatch({
                                type: 'HANDLE_ORG_EDIT_CHECKBOX',
                                payload: {
                                  checked: e.target.checked,
                                  organization: o,
                                },
                              });
                            }
                          });
                        }
                      }}
                    />
                  ) : null}
              </th>
              {details.map((model) => (
                <th className="p-2" key={model.id}>
                  {model.name}
                </th>
              ))}
            </tr>
          </thead>

          <CarrierList />
        </Table>
      </>
    );
  }
}

const mapStateToProps = (store) => ({
  editLogoMode: store.modals.editLogoMode,
  logosList: store.logos.logosList,
  organizationActivePage: store.logos.organizationActivePage,
  organizationsList: store.logos.organizationsList,
  organizationFilter: store.logos.organizationFilter,
  editMultipleSelections: store.logos.editMultipleSelections,
  organizationsToEdit: store.logos.organizationsToEdit,
});

export default connect(mapStateToProps)(EditSection);
